export enum IRMeterTypeEnum {
  HM_B_02 = 'Diehl Sharky',
  HM_B_00 = 'Engelmann / S3C',
  HM_B_01 = 'Itron / Echo 2',
  HM_D_00 = 'Kamstrup / M601',
  HM_D_01 = 'Kamstrup / M603',
  LANDIS_GYR_E350 = 'Landis+Gyr E350',
  HM_C_00 = 'Landis+Gyr T330',
  HM_A_00 = 'Landis+Gyr UH50',
  SML = 'sml',
  ALE3D5F = 'ale3d5f '
}
